import { notification } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import loginSession from '@/utils/loginSession';
import menuConfig from './menu';

function requestHandler(config) {
  const defaultOptions = {
    credentials: 'include',
  };
  const newOptions = { ...defaultOptions, ...config };

  if (newOptions.method === 'post' || newOptions.method === 'put' || newOptions.method === 'patch' || newOptions.method === 'delete') {
    // eslint-disable-line
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
      ...newOptions.headers,
    };
    if (typeof newOptions.body !== 'string') newOptions.body = JSON.stringify(newOptions.body);
    newOptions.data = newOptions.body;
    delete newOptions.body;
  } else {
    newOptions.headers = {
      'X-Requested-With': 'XMLHttpRequest',
      ...newOptions.headers,
    };
    let { url } = newOptions;
    const symbol = url.indexOf('?') > -1 ? '&' : '?';
    url += `${symbol}_=${Math.random()}`;
    newOptions.url = url;
  }
  const currentUser = loginSession.getUser();
  const { _csrf } = currentUser;
  if (_csrf) {
    newOptions.headers[_csrf.headerName] = _csrf.token;
  }
  return newOptions;
}

function matchCodeMes(response) {
  const codeMessage = {
    200: i18n('REQUEST_200'),
    201: i18n('REQUEST_201'),
    202: i18n('REQUEST_202'),
    204: i18n('REQUEST_204'),
    400: i18n('REQUEST_400'),
    401: i18n('REQUEST_401'),
    403: i18n('REQUEST_403'),
    404: i18n('REQUEST_404'),
    406: i18n('REQUEST_406'),
    410: i18n('REQUEST_410'),
    422: i18n('REQUEST_422'),
    500: i18n('REQUEST_500'),
    502: i18n('REQUEST_502'),
    503: i18n('REQUEST_503'),
    504: i18n('REQUEST_504'),
  };
  // eslint-disable-next-line no-mixed-operators
  const errortext = response && response.message || response && codeMessage[response.status] || undefined;
  return errortext;
}

function handleResponse(result) {
  return result;
}

function responseErrorHandler(error) {
  const result = {
    success: false,
    data: null,
    errorMsg: undefined,
  };
  let message;
  let code;
  let type;
  let data;
  let status;
  if (error.response) {
    ({ data, status } = error.response);
  }

  if (data) {
    ({ message, code, type } = data);
  }

  if (code === undefined) {
    code = status;
  }
  message = matchCodeMes(data);

  if (message === undefined) {
    message = error.message || error;
  }

  if (code === undefined) {
    code = -1;
  }
  if (code === 'S-SYS-00027' && error.config.url.indexOf('logout') <= -1) {
    // @HACK
    /* eslint-disable no-underscore-dangle */
    // TODO 改成了sessionStorage之后，应该不需要了，暂时注释
    window.g_app._store.dispatch({
      type: 'login/logout',
    });
  }

  /* type = 0 系统异常弹出警告 */
  if (type === 0 && code !== 'POT-USR-00062') {
    notification.error({
      message: i18n('REQUEST_ERROR'),
      description: message,
    });
  }

  result.errorMsg = message;
  result.data = data;
  return { data: result };
}

// themeList颜色有：极客蓝，薄暮红，酱紫
const config = {
  logger: {
    level: 'silent', // 屏蔽控制台 dva 日志 日志级别有https://fish.iwhalecloud.com/fishx-desktop-v2/fishx/docs/tools/logger/
  },
  rest: {
    interceptor: {
      // 配置拦截器
      requests: [requestHandler],
      responses: [handleResponse, responseErrorHandler],
    },
  },
  themeList: [
    {
      key: 'geek-blue',
      color: '#4477EE',
    },
    {
      key: 'dust-red',
      color: '#F5222D',
    },
    {
      key: 'golden-purple',
      color: '#722ED1',
    },
  ],
  // basename: '/portal',//Fishx.config可能被远程服务覆盖，不要使用
  ...menuConfig,
};

export default config;
